// import { log } from '../helpers'

import { getFormattedDate } from 'utils'

export const getCurrentlyMonitoring = monitor => {
  return monitor.activeItemsMonitoring + monitor.inactiveItemsMonitoring
}

export const getBusinessProfileComplete = model => {
  let out = 0
  const fields = [
    model.details.businessName || model.company,
    model.details.businessPhone || model.phone || '',
    model.details.photoFileId,
    model.details.socialFacebook || '',
    model.details.socialInstagram || '',
    model.details.socialTwitter || '',
    model.details.socialLinkedIn || '',
    model.details.businessDescription || '',
    model.details.category || model.sic || '',
    model.details.website || model.web || '',
    model.details.businessEmail || model.email || '',
    model.details.primaryContact.firstName || model.cont_name || '',
    model.details.primaryContact.lastName || '',
    model.details.primaryContact.contact || '',
    model.details.primaryContact.title || model.contact_title_desc || '',
    model.details.addressCity || '',
    model.details.addressCountry || '',
    model.details.addressState || '',
    model.details.addressStreet || '',
    model.details.addressZip || '',
  ]
  const percentForOne = 100 / fields.length
  fields.map(item => (item.length > 0 ? (out += percentForOne) : out))
  return parseInt(`${out}`)
}

export const getAccountProfileComplete = model => {
  let out = 0
  const fields = [
    model.firstName,
    model.lastName,
    model.businessTitle,
    model.address,
    model.city,
    model.state,
    model.zip,
    model.avatarUrl,
    // model.businessDescription
    // model.primaryContact
  ]
  const percentForOne = 100 / fields.length
  fields.map(item => (item.length > 0 ? (out += percentForOne) : out))
  return parseInt(`${out}`)
}

const formatUSDate = date =>
  new Date(date * 1000).toLocaleDateString('en-US', {
    day: '2-digit',
    year: 'numeric',
    month: '2-digit',
  })

const createSubscriptionPlanHistoryItem = data => {
  try {
    const subscription = createSubscription(data.lines.data[0])
    const isPromoCode = !!(data.discount && data.discount.promotion_code && data.discount.coupon)

    return {
      id: data.id,
      title: isPromoCode ? 'Promo Code' : subscription.title,
      price: isPromoCode ? `${data.discount.coupon.duration_in_months} Months` : subscription.price,
      paidOn: formatUSDate(isPromoCode ? data.discount.start : data.status_transitions.paid_at),
      card: String(data.card),
    }
  } catch (error) {
    throw new Error('Incorrect data for "Subscription Plan history item"')
  }
}

const getProductTitle = stripePriceId => {
  switch (stripePriceId) {
    // TODO: just commented for, will remove later
    // case products.individual.price.montly.stripeId:
    // case products.individual.price.yearly.stripeId:
    //   return products.individual.title
    case products.business.price.montly.stripeId:
      // case products.business.price.yearly.stripeId:
      return products.business.title
    default:
      return 'Business/Individual (deprecated) subscription'
  }
}

const createSubscription = data => {
  try {
    const nextPaymentDue = formatUSDate(data.current_period_end)
    const { interval } = data.plan
    const intervalTitled = interval.substr(0, 1).toUpperCase() + interval.substr(1)
    const price = `$${data.plan.amount / 100} / ${intervalTitled}`

    return {
      id: data.id,
      title: getProductTitle(data.plan.id),
      price: price,
      nextPaymentDue,
      status: data.status,
      discountEndDate: data.discount && data.discount.end ? new Date(data.discount.end * 1000) : null,
    }
  } catch (error) {
    // log.info(error)
    throw new Error('Incorrect data for "Subscription Plan"')
  }
}

// TODO: rewrite with data: unknown
export const createSubscriptionState = data => {
  try {
    // TODO: should be "subscripTION" not items
    // should read only [0] item
    const subscriptions = data.subscriptions.data.filter(item => item.status === 'active').map(createSubscription)
    const billingHistory = (data.invoices.data || []).map(createSubscriptionPlanHistoryItem)
    return { subscriptions, billingHistory }
  } catch (error) {
    // log.info(error)
    throw new Error('Incorrect data for "Subscription State"')
  }
}

// TODO: change data type to unknown and rewrite
export const createPaymentMethod = data => {
  try {
    return {
      service: data?.card?.brand.toUpperCase(),
      card: `xxxx-xxxx-xxxx-${data?.card?.last4}`,
      exp: `${('0' + data.card.exp_month).substr(-2)}/${data.card.exp_year}`,
      added: getFormattedDate(new Date(data.created * 1000), 'mm/dd/yyyy'),
    }
  } catch (error) {
    // log.info(error)
    throw new Error('Incorrect data for "Payment Method"')
  }
}

export const createPaymentMethod2 = data => {
  try {
    return {
      service: data.service,
      card: data.service,
      exp: data.exp,
      added: new Date(data.added),
    }
  } catch (error) {
    throw new Error('Incorrect data for "Payment Method"')
  }
}

export const createAccountType = data => {
  switch (data) {
    case 'free':
      return 'free'
    case 'premium':
      return 'premium'
    // TODO: add throw error
    default:
      return 'free'
  }
}

export const createValidatedDate = data => {
  if (data) {
    return new Date(data)
  }
  return undefined
}

export const createSubscriptionState2 = data => {
  if (data instanceof Object) {
  }

  throw new Error('Incorrect data')
}

export const createBusiness = data => {
  // TODO: remove forced type assertion
  return {
    ...data,
    phone: data.phone || '',
    id: data.id || Math.random().toString(),
    company: makeTitled(data.company),
    city: data.city ? makeTitled(data.city) : '',
    address: data.address ? makeTitled(data.address) : '',
    legal_name: data.legal_name ? makeTitled(data.legal_name) : '',
    cont_name: data.cont_name ? makeTitled(data.cont_name) : '',
    contact_first_name: data.contact_first_name ? makeTitled(data.contact_first_name) : '',
    contact_last_name: data.contact_last_name ? makeTitled(data.contact_last_name) : '',
  }
}

const excludes = ['tv']
const makeTitled = str => {
  return str
    .trim()
    .toLowerCase()
    .split(' ')
    .filter(str => str) // remove double spaces between words
    .map(part => {
      if (excludes.includes(part)) return part.toUpperCase()
      return part[0].toUpperCase() + part.substr(1, part.length)
    })
    .join(' ')
}

export const products = {
  // TODO: just commented for, will remove later
  // individual: {
  //   title: 'Individual',
  //   features: [
  //     'Access the Markaaz Directory of 119m verified businesses',
  //     'Find existing and new suppliers and partners, all verified',
  //     'Monitor your selected list of suppliers and partners'
  //   ],
  //   price: {
  //     montly: {
  //       value: 4.99,
  //       period: 'mo',
  //       title: 'Monthly',
  //       promotionText: null,
  //       stripeId: String(process.env['REACT_APP_STRIPE_PRODUCT_ID_INDIVIDUAL_MONTHLY'])
  //     },
  //     yearly: {
  //       value: 50,
  //       period: 'yr',
  //       promotionText: '2 mo. FREE',
  //       title: 'Annually',
  //       stripeId: String(process.env['REACT_APP_STRIPE_PRODUCT_ID_INDIVIDUAL_YEARLY'])
  //     }
  //   }
  // },
  business: {
    title: 'Premium',
    features: [
      'Edit your business photo',
      'Edit your company description',
      'Edit your socials',
      'Receive business health metrics',
      'Add your key people',
      'Display additional fields on your profile',
      'Get easy to understand visuals',
    ],
    price: {
      montly: {
        value: 4.99,
        period: 'mo',
        title: 'Monthly',
        promotionText: null,
        stripeId: String(process.env['REACT_APP_STRIPE_PRODUCT_ID_PREMIUM_MONTHLY']),
      },
      // yearly: {
      //   value: 50,
      //   // promotionText: '10% off',
      //   promotionText: '2 mo. FREE',
      //   period: 'yr',
      //   title: 'Annually',
      //   stripeId: String(process.env['REACT_APP_STRIPE_PRODUCT_ID_PREMIUM_YEARLY'])
      // }
    },
  },
}

export const getAccountTypeByPriceId = stripePriceId => {
  switch (stripePriceId) {
    // TODO: just commented for, will remove later
    // case products.individual.price.montly.stripeId:
    // case products.individual.price.yearly.stripeId:
    //   return 'individual'
    case products.business.price.montly.stripeId:
      // case products.business.price.yearly.stripeId:
      return 'premium'
    default:
      return 'premium'
    // throw new Error('Wrong price id')
  }
}

export const createUser = data => {
  if (data instanceof Object) {
    const user = {
      id: 'id',
      email: '',
      firstName: '',
      lastName: '',
      prefName: '',
      avatarUrl: '',
      avatarFileId: 'avatarFileId' in data ? data['avatarFileId'] : '',
      businessTitle: '',
      securedDate: null,
      businessDescription: '',
      primaryContact: '',

      zip: 'zip' in data ? data['zip'] : '',
      address: 'address' in data ? data['address'] : '',
      city: 'city' in data ? data['city'] : '',
      state: 'state' in data ? data['state'] : '',

      phone: 'phone' in data ? data['phone'] : '',

      ssn: 'ssn' in data ? data['ssn'] : '',

      kycValidated: undefined,
      kybValidated: undefined,
      hasMessages: true,

      accountType: 'free',
      product: null,
      price: null,
      explanatoryPageBeenShowed: false,
      business: null,

      monitorIds: [],
      accessPeriodEnd: null,
      paymentMethod: null,
      kycData: 'kycData' in data ? (data['kycData'] === null ? null : createKYCUser(data['kycData'])) : null,

      kybSessionId: 'kybSessionId' in data ? data['kybSessionId'] : null,
      kyb2SessionId: 'kyb2SessionId' in data ? data['kyb2SessionId'] : null,
      businessId: 'businessId' in data ? data['businessId'] : null,
      businessIds: 'businessIds' in data ? data['businessIds'] : null,
    }

    if ('email' in data) {
      user.email = data['email']
    }

    if ('firstName' in data) {
      user.firstName = data['firstName']
    }

    if ('lastName' in data) {
      user.lastName = data['lastName']
    }

    if ('prefName' in data) {
      user.prefName = data['prefName']
    }

    if ('businessTitle' in data) {
      user.businessTitle = data['businessTitle']
    }

    if ('business' in data) {
      user.business = data.business
    }

    if ('avatarUrl' in data) {
      user.avatarUrl = data['avatarUrl']
    }

    if ('accessPeriodEnd' in data) {
      const date = new Date(data['accessPeriodEnd'])
      if (!Number.isNaN(date.getTime())) {
        user.accessPeriodEnd = date
      }
    }

    if ('created_date' in data) {
      const date = new Date(data['created_date'])
      if (!Number.isNaN(date.getTime())) {
        user.created_date = date
      }
    }

    if ('accountType' in data) {
      user.accountType = data['accountType']
      if (!(user.accountType === 'premium' || user.accountType === 'free')) {
        // log.info('Wrong (old) account type for user', user)
      }
    }

    if ('kycDate' in data) {
      const value = data['kycDate']
      if (value) {
        user.kycValidated = new Date(value)
      }
    }

    if ('kybDate' in data) {
      const value = data['kybDate']
      if (value) {
        user.kybValidated = new Date(value)
      }
    }

    // TODO: for what is this field?
    if ('securedDate' in data) {
      const date = new Date(data['securedDate'])
      if (!Number.isNaN(date.getTime())) {
        user.securedDate = date
      }
    }

    if ('user' in data) {
      user.id = data['user']
    }

    if ('paymentMethod' in data) {
      user.paymentMethod = createPaymentMethod2(data['paymentMethod'])
    }

    // user.avatarUrl = localStorage.getItem(AVATAR_LOCALSTORAGE_KEY) || ''

    return user
  }

  throw new Error('Error')
}

// TODO: improve
export const createKYCUser = data => {
  try {
    const address = data.addresses[0] || {}
    const out = {
      name: {
        firstName: data.name.firstName,
        lastName: data.name.lastName,
      },
      addresses: [
        {
          zipCode: address.zipCode,
          state: address.state,
          type: address.type,
          streetAddress: address.streetAddress,
          city: address.city,
        },
      ],
      id: data.id,
      contact: {
        mobile: data.contact.mobile,
        email: data.contact.email,
      },
    }
    return out
  } catch (error) {
    throw new Error('Error')
  }
}

// {
//   address: {
//     apartmentNumber: '001',
//     streetName: '1 Main St',
//     addressLine1: '1 Address Way',
//     addressLine2: 'Near EFX Lake',
//     city: 'Atlanta',
//     state: 'GA',
//     zip: '30001',
//     country: 'US'
//   },
//   contactDetail: [
//     {
//       type: 'Mobile',
//       value: phone
//     }
//   ],
//   firstName: 'John',
//   middleName: 'J',
//   lastName: 'Paul',
//   ssn: ssn,
//   // emailAddress: `john.paul${random}@example.com`,
//   // emailAddress: `dkolomeiets@intersog.com`,
//   emailAddress: 'artemkfg31@example.com',
//   // emailAddress: `bob${random}@example.com`,
//   suffix: 'Mr.',
//   dateOfBirth: '1980-01-01'
// }

export const createStripePromotionCode = data => {
  return {
    id: data.id,
    code: data.code,
    active: data.active,
    coupon: {
      percent_off: data.coupon.percent_off,
    },
    metadata: data.metadata,
    expires_at: data.expires_at,
  }
}

export const getKYBData = (business, user) => {
  return {
    businessId: business.ext_id,
    borrower: {
      address: {
        streetName: '',
        addressLine1: user.address,
        addressLine2: '',
        city: user.city,
        state: user.state,
        zip: user.zip,
        country: '',
        apartmentNumber: '',
      },
      firstName: user.firstName,
      middleName: '',
      lastName: user.lastName,
      suffix: '',
      dateOfBirth: '',
      ssn: '489-36-8350',
      emailAddress: user.email,
      contactDetail: [{ type: 'Mobile', value: user.phone }],
    },
  }
}

export const getBusinessFullAddress = model => {
  const parts = [
    model.details.addressStreet || model.address,
    model.details.addressCity || model.city,
    model.details.addressState || model.state || model.region,
    model.details.addressZip || model.zip,
    model.details.addressCountry || model.country,
  ]

  return parts.filter(part => part).join(', ')
}

export const checkIsAccountExpired = user => {
  let isAccessExpired

  if (user.accessPeriodEnd) {
    isAccessExpired = user.accessPeriodEnd.getTime() < Date.now()
  } else {
    isAccessExpired = false
  }

  return isAccessExpired
}
